export class ApiError {
  constructor(public status?: number) {}
}
